import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Fragment } from "react";
import { Button, Col, Form, Image, Modal, Row, Table } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import Media from "react-media";
import Alert from "react-s-alert";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Loader from "react-loader-spinner";

import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import {
  get_all_global_cateloge_menu,
  get_all_global_cateloge_menu_category,
  get_all_global_cateloge_menu_category_item,
} from "../../../../store/actions/AddItemGlobalCatelogAction/addItemGlobalCatelogAction";
import {
  SET_CURRENT_ACTIVE_CATELOGE_ID,
  SET_CURRENT_ACTIVE_CATEGORY_ID,
  GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM,
  SET_ALL_COMPLETE_ITEMS,
} from "../../../../store/types";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";

const SelectedItemFromCategoryInside = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const token = props.auth.user.accessToken;
  const [loading, setLoading] = useState(true);

  /***************************************
   * @DESC Render Api Call
   ***************************************/
  useEffect(() => {
    dispatch({
      type: SET_CURRENT_ACTIVE_CATELOGE_ID,
      payload: "",
    });
    dispatch({
      type: SET_CURRENT_ACTIVE_CATEGORY_ID,
      payload: "",
    });
    dispatch({
      type: GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM,
      payload: [],
    });
    dispatch(
      get_all_global_cateloge_menu(token, (data) => onSuccessCateloge(data))
    );
  }, []);

  const onSuccessCateloge = (data) => {
    setLoading(data);
  };

  /******************************************************
   * @DESC Cateloge Category API Action
   *****************************************************/
  useEffect(() => {
    if (
      props.activeCatelogeId !== "" &&
      props.activeCatelogeId !== null &&
      props.activeCatelogeId !== undefined
    ) {
      dispatch(
        get_all_global_cateloge_menu_category(props.activeCatelogeId, token)
      );
    }
  }, [props?.activeCatelogeId]);

  useEffect(() => {
    if (
      props.activeCategoryId !== "" &&
      props.activeCategoryId !== null &&
      props.activeCategoryId !== undefined
    ) {
      dispatch(
        get_all_global_cateloge_menu_category_item(
          props.activeCategoryId,
          props.activeCatelogeId,
          token
        )
      );
    }
  }, [props?.activeCategoryId, props?.activeCatelogeId]);

  /***************************************
   * @DESC Catelogue Button Action
   ***************************************/
  const changeActiveStatus = (id) => {
    dispatch({
      type: SET_CURRENT_ACTIVE_CATELOGE_ID,
      payload: id,
    });
  };

  /***************************************
   * @DESC Category Button Action
   ***************************************/
  const changeCategoryActiveStatus = (id) => {
    dispatch({
      type: SET_CURRENT_ACTIVE_CATEGORY_ID,
      payload: id,
    });
  };

  const [allCategory, setCategory] = useState();
  useEffect(() => {
    let chars = props.get_Cateloge_category;
    uniqByKeeLast(chars, (it) => it.category.name);
  }, [props.get_Cateloge_category]);

  const uniqByKeeLast = (data, key) => {
    let dataArr = [...new Map(data.map((x) => [key(x), x])).values()];
    return setCategory(dataArr);
  };

  /*****************************************
   * @DESC Checkbox Category button
   ******************************************/
  const [actualMenuData, setActualMenuData] = useState([]);
  const addCheck = (e, value) => {
    if (e.target.checked) {
      //append to array
      setActualMenuData(actualMenuData.concat([value]));
    } else {
      //remove from array
      setActualMenuData(
        actualMenuData.filter(function (val) {
          return val !== value;
        })
      );
    }
  };

  useEffect(() => {
    dispatch({
      type: SET_ALL_COMPLETE_ITEMS,
      payload: actualMenuData,
    });
  }, [actualMenuData]);

  const proceedFinalCatelogueItem = () => {
    if (props?.selectedItems.length > 0) {
      if (history.location.pathname === "/onboard-additem-from-catalogue") {
        history.push({
          pathname: "/onboard-select-items-from-catalogue",
          state: history.location.pathname,
        });
      } else {
        history.push("/select-items-from-catalogue");
      }
    } else {
      Alert.error(`<h4>Please select cateloge items</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  // props.get_Cateloge_category_item

  const mainDisplay = () => {
    return (
      <div
        className="mb-5"
        // {`onboarding_process_screen-button-map`}
      >
        <Row className="align-items-center">
          <Col lg={12} className="pl-lg-0">
            <div className="mb-4">
              <TopTextReusableComponent
                headingText="Select Items"
                headingParagraph="(Select the items from the categories and cuisines selected before that you want to provide from this catalogue"
              />
            </div>
          </Col>
          <Col lg={5} className="pl-lg-0">
            <Form.Control
              type="text"
              placeholder="Search"
              className="amSearch"
              style={{ backgroundColor: "#fff" }}
            />
          </Col>
          <Media query="(min-width: 992px)">
            <Col lg={7} className="text-right">
              <Button
                variant="danger"
                className="btn150px btn-lg px-5"
                // onClick={() => handleShowZNextStepModal()}
                onClick={() => proceedFinalCatelogueItem()}
              >
                Proceed
              </Button>
            </Col>
          </Media>
        </Row>
        <Row>
          <Media query="(min-width: 992px)">
            <Col lg={5} className="pl-md-0">
              <Row>
                <Col md={6} className="pr-md-1">
                  <div className="bg-white enP075rem f16-500">
                    Global Catalogue
                  </div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList min-vh-100 p-1">
                      {loading ? (
                        <div className="mt-5 text-center">
                          <Loader
                            type="Puff"
                            color="#00BFFF"
                            height={49}
                            width={49}
                          />
                        </div>
                      ) : (
                        props?.get_all_Cateloges &&
                        props?.get_all_Cateloges.map((global, index) => (
                          <button
                            type="button"
                            className={`f14-400 ${
                              global._id === props?.activeCatelogeId
                                ? "active"
                                : ""
                            }`}
                            key={index}
                            onClick={() => changeActiveStatus(global._id)}
                            title={global.name}
                          >
                            {global.name}
                          </button>
                        ))
                      )}
                    </div>
                  </Scrollbars>
                </Col>
                <Col md={6} className="pl-md-0">
                  <div className="bg-white enP075rem f16-500">Categories</div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList min-vh-100 p-1">
                      {props.auth.loader ? (
                        <div className="mt-5 text-center">
                          <Loader
                            type="Puff"
                            color="#00BFFF"
                            height={49}
                            width={49}
                          />
                        </div>
                      ) : (
                        allCategory &&
                        allCategory.map((category, index) => (
                          <button
                            type="button"
                            className={`f14-400 ${
                              category?.category?._id ===
                              props?.activeCategoryId
                                ? "active"
                                : ""
                            }`}
                            key={index}
                            onClick={() =>
                              changeCategoryActiveStatus(
                                category?.category?._id
                              )
                            }
                            title={category?.category?.name}
                          >
                            {category?.category?.name}
                          </button>
                        ))
                      )}
                    </div>
                  </Scrollbars>
                </Col>
              </Row>
            </Col>
          </Media>
          <Media query="(max-width: 991px)">
            <Col xs={12} className="pt-3">
              <Row>
                <Col xs={6}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel htmlFor="outlined-GlobalCatalogue">
                      Global Catalogue
                    </InputLabel>
                    <Select
                      // value={globalActiveId}
                      id="GlobalCatalogue"
                      onChange={
                        () => {}
                        // (e) => changeActiveStatus(e.target.value)
                      }
                      // onChange={(e) => handleChangeCategory(e)}
                      label="Global Catalogue"
                      inputProps={{
                        name: "GlobalCatalogue",
                        id: "outlined-GlobalCatalogue",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {props?.get_all_Cateloges &&
                        props?.get_all_Cateloges.map((item, index) => (
                          <MenuItem key={index} value={item?.name}>
                            {item?.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={6}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel htmlFor="outlined-Categories">
                      Categories
                    </InputLabel>
                    <Select
                      // value={activeCategoryId}
                      id="Categories"
                      onChange={(e) => {
                        // var tempData = actualMenuData.filter((d) => {
                        //   return d._id === e.target.value;
                        // });
                        // if (tempData && tempData.length > 0) {
                        //   setItemsForCategory(
                        //     tempData[0].items,
                        //     tempData[0]._id
                        //   );
                        // }
                      }}
                      label="Categories"
                      inputProps={{
                        name: "Categories",
                        id: "outlined-Categories",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {allCategory &&
                        allCategory.map((item, index) => (
                          <MenuItem key={index} value={item?.category?.name}>
                            {item?.category?.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
            </Col>
          </Media>
          <Col lg={7} className="text-right pl-lg-0">
            <div className="user-table-reusable-superadmin table-responsive mobile_table">
              <Table className="enAuditLogTBL HideShowTable text-left">
                <thead>
                  <tr className="super_admin_all_users_table_head rounded-0">
                    <th className="f12-700" style={{ width: "20%" }}>
                      Item ID
                    </th>
                    <th className="f12-700" style={{ width: "20%" }}>
                      Item Name
                    </th>
                    <th className="f12-700" style={{ width: "40%" }}>
                      Description
                    </th>
                    <th className="f12-700" style={{ width: "20%" }}>
                      Select
                    </th>
                  </tr>
                </thead>
                {props.auth.secondary_loader ? (
                  <div className="mt-5 text-center">
                    <Loader
                      type="Puff"
                      color="#00BFFF"
                      height={49}
                      width={49}
                    />
                  </div>
                ) : (
                  props.get_Cateloge_category_item &&
                  props.get_Cateloge_category_item.map((item, index) => (
                    <Fragment key={index}>
                      {/* {item.status ? ( */}
                      <tbody>
                        <tr className="super_admin_all_users_table_body">
                          <td style={{ width: "20%" }}>
                            <div className="f14-500 text-break">
                              #ID
                              {item?._id}
                            </div>
                            <div className="enIMG62 mt-2">
                              <Image
                                //src={require("../../../../../assets/images/UserManagement/items.png")}
                                src={item && item?.images && item?.images[0]}
                                alt="item img"
                                title="item img"
                                fluid
                                width="100%"
                                height="100%"
                              />
                            </div>
                          </td>
                          <td style={{ width: "20%" }}>
                            <div className="d-flex mt-2 align-items-center">
                              {ITEMTYPEVEG.map((type, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {item && item?.itemType === type?.value ? (
                                      <Image
                                        width="20px"
                                        fluid
                                        src={type.url}
                                        alt={type.title}
                                        title={type.title}
                                      />
                                    ) : null}
                                  </React.Fragment>
                                );
                              })}
                              <div className="f14-500 pl-2 text-break">
                                {item?.name}
                              </div>
                            </div>
                            <hr />
                            <div className="d-flex mt-2 align-items-center">
                              {props.foodTypecategory &&
                                props.foodTypecategory.map((type, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      {item?.primary_food_type === type?._id ? (
                                        <div className="d-flex">
                                          <Image
                                            width="16px"
                                            fluid
                                            src={type?.icon}
                                            alt={type?.title}
                                            title={type?.title}
                                          />
                                          <div className="f14-500 pl-2">
                                            {" "}
                                            {type?.title}
                                          </div>
                                        </div>
                                      ) : null}
                                    </React.Fragment>
                                  );
                                })}
                            </div>
                          </td>
                          <td style={{ width: "45%" }}>
                            <div className="f14-500">{item?.description}</div>
                          </td>
                          <td style={{ width: "15%" }}>
                            <Form.Check
                              key={item}
                              // checked={item.checked}
                              label="Add"
                              inline
                              name="list"
                              type="checkbox"
                              className="enCheckBoxOnly"
                              onClick={(e) => addCheck(e, item)}
                            />
                          </td>
                        </tr>
                      </tbody>
                      {/* ) : (
                      <> </>
                    )} */}
                    </Fragment>
                  ))
                )}
              </Table>
            </div>
            <Media query="(max-width: 992px)">
              <Button
                variant="danger"
                className="w-100 btn-lg px-5"
                // onClick={() => handleShowZNextStepModal()}
                onClick={() => proceedFinalCatelogueItem()}
              >
                Proceed
              </Button>
            </Media>
            {/* <div className="fixed-bottom bg-white border-top p-2">
          <Button
            variant="danger"
            className="w-100 btn-lg px-5"
            onClick={handleShowZNextStepModal}
          >
            Proceed
          </Button>
        </div> */}
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <React.Fragment>
      {/* {console.log(
        "get_Cateloge, ===>",
        catelogeId,
        "get_category, ===>",
        categoryId
      )} */}
      {mainDisplay()}
      <Modal
        // show={nextStepModal}
        // onHide={handleCloseZNextStepModal}
        centered
        className="xl-width-750"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f20-700 pb-2">Alert</Modal.Title>
            <div className="d-flex justify-content-between">
              <p className="f14-400">Please Select from below</p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <Form>
            <label className="enRadioWithText f12-400 w-100 mb-3">
              Upload all the cuisines and categories without editing
              <input type="radio" name="CouponDiscountType" />
              <span class="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-400 w-100">
              Edit all the categories one by one, before submitting
              <input type="radio" name="CouponDiscountType" />
              <span class="checkmark"></span>
            </label>
          </Form>
          <div className="d-flex align-items-center py-4">
            <Button
              variant="outline-secondary"
              className="btn150px btn-lg mr-4 px-5"
              // onClick={handleCloseZNextStepModal}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn150px btn-lg px-5"
              // onClick={onWithOutApiCall}
            >
              Proceed
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SelectedItemFromCategoryInside.propTypes = {
  auth: PropTypes.object.isRequired,
  get_all_global_cateloge_menu: PropTypes.func.isRequired,
  get_all_global_cateloge_menu_category: PropTypes.func.isRequired,
  get_all_global_cateloge_menu_category_item: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  foodTypecategory: state.category?.foodtype,
  activeCatelogeId: state.merchantItemCateloge?.set_current_active_cateloge_id,
  activeCategoryId: state.merchantItemCateloge?.set_current_active_category_id,
  get_all_Cateloges: state.merchantItemCateloge?.getAllGlobalCateloge,
  get_Cateloge_category:
    state.merchantItemCateloge?.getAllGlobalCatelogeCategory,
  get_Cateloge_category_item:
    state.merchantItemCateloge?.getAllGlobalCatelogeCategoryItem,
  selectedItems: state.merchantItemCateloge?.set_all_complete_items,
});

export default connect(mapStateToProps, {
  get_all_global_cateloge_menu,
  get_all_global_cateloge_menu_category,
  get_all_global_cateloge_menu_category_item,
})(withRouter(SelectedItemFromCategoryInside));

// const handleShowZNextStepModal = () => {
//   // props.history.push({
//   //   pathname: "/superadmin-global-catalogue/catalogue",
//   // });
//   //

//   const prepareData = {};
//   prepareData.category = [];
//   prepareData.items = [];
//   let categoryId = [];
//   let itemArrayToDispatch = [];

//   let checkedArray = [];
//   for (let i = 0; i < actualMenuData.length; i++) {
//     if (!categoryId.includes[actualMenuData[i]._id]) {
//       prepareData.category.push({
//         categoryId: actualMenuData[i]._id,
//         is_temp_local: false,
//       });
//     }
//     for (let j = 0; j < actualMenuData[i].items.length; j++) {
//       if (actualMenuData[i].items[j].checked) {
//         checkedArray.push(actualMenuData[i].items[j]._id);
//         let tempData = { ...actualMenuData[i].items[j] };
//         tempData.categoryName = actualMenuData[i].name;
//         itemArrayToDispatch.push(tempData);
//         tempData = {};
//         prepareData.items.push({
//           itemId: actualMenuData[i].items[j]._id,
//           is_temp_local: false,
//         });
//       } else {
//         prepareData.items.push({
//           itemId: actualMenuData[i].items[j]._id,
//           is_temp_local: true,
//         });
//       }
//     }
//   }

//   if (checkedArray.length === 0) {
//     Alert.error(`<h4>Please select atleast one item too proceed </h4>`, {
//       position: "top-right",
//       effect: "bouncyflip",
//       beep: true,
//       html: true,
//       timeout: 3000,
//       offset: 35,
//     });
//   } else {
//     const formData = {};
//     formData.items = checkedArray;
//     dispatch({ type: SELECTED_CATALOG_ITEMS, payload: itemArrayToDispatch });
//     dispatch({ type: SELECTED_ITEMS_ID, payload: checkedArray });
//     dispatch({
//       type: CATALOG_SELECTED_CATEGORIES_ITEMS,
//       payload: prepareData,
//     });

//     if (props.dash) {
//       history.push("/selecteditemsnew");
//     } else {
//       history.push(
//         "/casual-fine-dining/menusetup/selectmenu/selecteditemsnew"
//       );
//     }
//     //setNextStepModal(true);
//   }
// };

// const addCheck = (status, itemId) => {
//   let updatedData = [...actualMenuData];
//   for (let i = 0; i < updatedData.length; i++) {
//     for (let j = 0; j < updatedData[i].items.length; j++) {
//       if (itemId === updatedData[i].items[j]._id) {
//         if (status !== undefined && status !== null) {
//           updatedData[i].items[j].checked = !status;
//         } else {
//           updatedData[i].items[j].checked = true;
//         }
//       }
//     }
//   }
//   setActualMenuData(updatedData);
// };
